module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "SelectableGridCell",
    class: {
      'active': _vm.isActive
    }
  }, [_c('a', {
    ref: "cell",
    attrs: {
      "href": "#"
    },
    on: {
      "focus": _vm.activate,
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d280333e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectableGridCell.vue
// module id = 1709
// module chunks = 1